import moment from 'moment';

import type { Moment } from 'moment';

/**
 * Generic search function that filters items based on search string and specified fields
 * @param searchStr - The search string to filter by
 * @param items - Array of items to search through
 * @param searchFields - Function that returns an array of fields to search in for each item
 * @param setSearchStr - Function to update the search string state
 * @param setFilteredItems - Function to update the filtered items state
 */
export const handleSearch = <T>(
  searchStr: string,
  items: T[],
  searchFields: (item: T) => (string | null | undefined)[],
  setSearchStr: (str: string) => void,
  setFilteredItems: (items: T[]) => void,
) => {
  setSearchStr(searchStr);

  const filtered = searchStr
    ? items.filter((item) => {
        const searchTerm = searchStr.toLowerCase();
        const fields = searchFields(item).map((field) => (field || '').toLowerCase());
        return fields.some((field) => field.includes(searchTerm));
      })
    : items;

  setFilteredItems(filtered);
};

/**
 * Common search field extractors
 */
export const searchFieldExtractors = {
  nameFields: (item: { first_name?: string; last_name?: string }) => [
    item.first_name,
    item.last_name,
  ],
  dateFields: (item: {
    date_start?: string | Moment | Date | null;
    date_end?: string | Moment | Date | null;
  }) => [
    moment(item.date_start).format('MM/DD/YYYY'),
    item.date_end ? moment(item.date_end).format('MM/DD/YYYY') : '',
  ],
};
